import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  IconButton,
  Typography,
} from '@mui/material';
import { DeleteOutline as DeleteIcon } from '@mui/icons-material';
import CustomPatientProfileAvatar from './CustomPatientProfileAvatar';
import { patientLabel, patientListSecondary, patientMeta } from '../../utils/myPatients';

const MyPatientListCard = ({ patient, onOpen, onDelete }) => {
  const named = Boolean(String(patient.personal?.name || '').trim());
  const label = patientLabel(patient);
  const meta = patientMeta(patient);
  const secondary = patientListSecondary(patient);

  return (
    <Card variant="outlined" sx={{ borderRadius: 1.5, overflow: 'hidden' }}>
      <CardActionArea onClick={() => onOpen(patient)} sx={{ p: 1.25, alignItems: 'stretch', display: 'block' }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <CustomPatientProfileAvatar patient={patient} size={40} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              fontWeight={700}
              color={named ? 'text.primary' : 'text.secondary'}
              sx={{ lineHeight: 1.3 }}
            >
              {label}
            </Typography>
            {meta ? (
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.25 }}>
                {meta}
              </Typography>
            ) : null}
            {secondary ? (
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
                sx={{
                  mt: 0.25,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {secondary}
              </Typography>
            ) : null}
          </Box>
          <IconButton
            size="small"
            aria-label={`Remove ${label}`}
            onClick={(event) => {
              event.stopPropagation();
              onDelete(patient);
            }}
            sx={{ mt: -0.5, mr: -0.5 }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default MyPatientListCard;
